import { render, staticRenderFns } from "./ConclusionDeresma.vue?vue&type=template&id=7580632e&scoped=true"
import script from "./ConclusionDeresma.vue?vue&type=script&lang=ts"
export * from "./ConclusionDeresma.vue?vue&type=script&lang=ts"
import style0 from "./ConclusionDeresma.vue?vue&type=style&index=0&id=7580632e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580632e",
  null
  
)

export default component.exports